import { Badge } from "./Badge";

export type AiSignalKind = "approve" | "review" | "flag";

/** Deterministic priority badge computed server-side from delivery-date
 * proximity and order quantity — see packages/shared/src/reviewSignal.ts. */
export function AiSignal({ kind }: { kind: AiSignalKind }) {
  if (kind === "approve") return <Badge tone="green">Likely Approve</Badge>;
  if (kind === "review") return <Badge tone="amber">Needs Review</Badge>;
  return <Badge tone="red">Likely Reject</Badge>;
}
